import { useEffect, useState } from "react";
import { NAV } from "@/constants/testIds/ashwin";

const links = [
  { id: "about", label: "About", testid: NAV.linkAbout },
  { id: "experience", label: "Work", testid: NAV.linkExperience },
  { id: "skills", label: "Craft", testid: NAV.linkSkills },
  { id: "contact", label: "Contact", testid: NAV.linkContact },
];

export default function Nav({ onOpenChat }) {
  const [scrolled, setScrolled] = useState(false);
  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 8);
    onScroll();
    window.addEventListener("scroll", onScroll);
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  const scrollTo = (id) => {
    const el = document.getElementById(id);
    if (el) el.scrollIntoView({ behavior: "smooth", block: "start" });
  };

  return (
    <header
      className={`fixed top-0 inset-x-0 z-40 transition-all duration-500 ${
        scrolled ? "py-3" : "py-5"
      }`}
    >
      <div
        className={`mx-4 md:mx-8 flex items-center justify-between px-5 md:px-8 py-3 transition-all duration-500 ${
          scrolled
            ? "glass-card border rounded-none"
            : "border border-transparent"
        }`}
      >
        <a
          href="#top"
          data-testid={NAV.logo}
          className="font-display text-lg md:text-xl font-medium tracking-tight"
        >
          Ashwin<span className="text-[color:var(--accent)]">.</span>Kalra
        </a>

        <nav className="hidden md:flex items-center gap-8 text-sm">
          {links.map((l) => (
            <button
              key={l.id}
              data-testid={l.testid}
              onClick={() => scrollTo(l.id)}
              className="editorial-link text-[color:var(--charcoal)] hover:text-[color:var(--accent)] transition-colors"
            >
              {l.label}
            </button>
          ))}
        </nav>

        <button
          data-testid={NAV.openChat}
          onClick={onOpenChat}
          className="text-xs md:text-sm font-medium px-4 py-2 bg-[color:var(--charcoal)] text-white hover:bg-[color:var(--accent)] transition-colors duration-300"
        >
          <span className="inline-block w-1.5 h-1.5 bg-emerald-400 rounded-full mr-2 align-middle animate-pulse" />
          Ask my AI
        </button>
      </div>
    </header>
  );
}
